/**
 * Import required libraries
 */
import React from "react";

/**
 * Import required elements
 */
// Material-ui components
import { MenuList, MenuItem, TextField } from "@material-ui/core";
import Header from "./header";

import styles from "./styles";

/**
 * Selection Component
 */
function Selection({ title, back, inputs, list }) {
  // CSS classnames
  const classes = styles();

  return (
    <div className={classes.root}>
      <Header title={title} back={back} />
      {inputs && inputs.map((input, index) =>
        <TextField key={index.toString()} {...input}/>
      )}
      <MenuList className={classes.menuList}>
        {list.map(e => (
          <MenuItem key={e.key} onClick={e.onClick}
            style={e.selected ? {
              backgroundColor: "rgba(52, 154, 25, 0.15)"
            } : null}
          >
            {e.icon}
            {e.label}
          </MenuItem>
        ))}
      </MenuList>
    </div>
  );
}

export default Selection;
